import { render } from "./PreenchimentoFormTarefa.vue?vue&type=template&id=2ae31702&scoped=true"
import script from "./PreenchimentoFormTarefa.vue?vue&type=script&lang=js"
export * from "./PreenchimentoFormTarefa.vue?vue&type=script&lang=js"

import "./PreenchimentoFormTarefa.vue?vue&type=style&index=0&id=2ae31702&lang=scss&scoped=true"
import "./PreenchimentoFormTarefa.vue?vue&type=style&index=1&id=2ae31702&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae31702"],['__file',"src/views/Formulario/Responder/components/PreenchimentoFormTarefa.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ae31702"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ae31702', __exports__)) {
    console.log('reload')
    api.reload('2ae31702', __exports__)
  }
  
  module.hot.accept("./PreenchimentoFormTarefa.vue?vue&type=template&id=2ae31702&scoped=true", () => {
    console.log('re-render')
    api.rerender('2ae31702', render)
  })

}


export default __exports__